__webpack_require__.p = "https://guild.host/assets/";